namespace Portico.Controllers {
    import Controller = Portico.Decorators.Controller;

    @Controller('app', 'pageController')
    export class PageController {}
}